// eslint-disable-next-line no-shadow
enum ActionTypes {
  ADD_CITY = 'ADD_CITY',
  DELETE_CITY = 'DELETE_CITY',
  ADD_SPECIALTIES = 'ADD_SPECIALTIES',
  DELETE_SPECIALTY = 'DELETE_SPECIALTY',
  ADD_AVAILABILITY = 'ADD_AVAILABILITY',
  RESET_FILTERS = 'RESET_FILTERS',
  ADD_STATE = 'ADD_STATE',
  DELETE_STATE = 'DELETE_STATE',
}

export default ActionTypes
